module.exports = __webpack_public_path__ + "static/media/digitalViewLogo.bc84b496.png";